export default __webpack_public_path__ + "static/media/rambouillet10.8160d107.jpg";